import { availableRules, defaultRuleFor } from "../summaryRules";

export default function TemplatePage({
  templateColumns,
  directories,
  actionColumns,
  updateTemplateColumn,
  addTemplateColumn,
  clearTemplate,
  removeTemplateColumn,
  moveTemplateColumn,
  launchTemplate,
  addActionColumn,
  updateActionColumn,
  removeActionColumn,
  templateMode,
  setTemplateMode,
  summaryRules,
  updateSummaryRule
}) {
  const isTwoLevel = templateMode === "two_level";

  return (
    <div>
      <h1>Шаблон создания платежа</h1>

      <div className="template-mode">
        <label>
          <input
            type="checkbox"
            checked={isTwoLevel}
            onChange={(e) => setTemplateMode(e.target.checked ? "two_level" : "single")}
          />
          Двухуровневый режим (платёж из нескольких строк)
        </label>
      </div>

      <div className="template-toolbar">
        <button onClick={addTemplateColumn}>
          Добавить столбец
        </button>

        <button onClick={clearTemplate}>
          Создать с нуля
        </button>

        <button className="launch-btn" onClick={launchTemplate}>
          Запустить шаблон
        </button>
      </div>

      {isTwoLevel && (
        <p className="template-hint">
          Столбцы ниже — это поля строк (второй уровень). На первом уровне настройте правила свёртки.
        </p>
      )}

      <div className="template-list">
        {templateColumns.map((column, index) => (
          <div className="template-row" key={column.id}>
            <input
              value={column.label}
              onChange={(e) =>
                updateTemplateColumn(column.id, "label", e.target.value)
              }
              placeholder="Название столбца"
            />

            <select
              value={column.format}
              onChange={(e) =>
                updateTemplateColumn(column.id, "format", e.target.value)
              }
            >
              <option value="text">Текст</option>
              <option value="number">Число</option>
              <option value="date">Дата</option>
              <option value="counterparty">Контрагент</option>
              {directories.map((directory) => (
                <option key={directory.id} value={`directory:${directory.id}`}>
                  {directory.savedName}
                </option>
              ))}
            </select>

            <label className="required-toggle">
              <input
                type="checkbox"
                checked={column.required}
                onChange={(e) =>
                  updateTemplateColumn(column.id, "required", e.target.checked)
                }
              />
              Обязательный
            </label>

            <button
              onClick={() => moveTemplateColumn(column.id, -1)}
              disabled={index === 0}
            >
              ↑
            </button>

            <button
              onClick={() => moveTemplateColumn(column.id, 1)}
              disabled={index === templateColumns.length - 1}
            >
              ↓
            </button>

            <button
              className="remove-column-btn"
              onClick={() => removeTemplateColumn(column.id)}
            >
              Удалить
            </button>
          </div>
        ))}
      </div>

      {isTwoLevel && (
        <div className="summary-settings">
          <h2>Первый уровень (сводка)</h2>
          <p>Как каждый столбец сворачивается в одну строку платежа.</p>

          <div className="summary-list">
            {templateColumns.map((column) => {
              const rules = availableRules(column);
              const currentRule = summaryRules[column.id] || defaultRuleFor(column);

              return (
                <div className="summary-row" key={column.id}>
                  <strong>{column.label}</strong>

                  <select
                    value={currentRule}
                    onChange={(e) => updateSummaryRule(column.id, e.target.value)}
                  >
                    {rules.map((rule) => (
                      <option key={rule.key} value={rule.key}>{rule.label}</option>
                    ))}
                  </select>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="actions-settings">
        <div className="actions-settings-head">
          <div>
            <h2>Столбцы выбора</h2>
            <p>
              Создавайте любые колонки с выпадающими списками: согласование, оплата, проверка и другие этапы.
            </p>
          </div>

          <button onClick={addActionColumn}>
            Добавить столбец выбора
          </button>
        </div>

        <div className="action-columns-list">
          {actionColumns.map((column) => (
            <div className="action-column-card" key={column.id}>
              <div className="action-column-main">
                <input
                  value={column.label}
                  onChange={(e) =>
                    updateActionColumn(column.id, "label", e.target.value)
                  }
                  placeholder="Название столбца"
                />

                <textarea
                  value={column.optionsText}
                  onChange={(e) =>
                    updateActionColumn(column.id, "optionsText", e.target.value)
                  }
                  placeholder={"Каждый вариант с новой строки\nНапример:\nНа проверке\nОдобрено\nОтказано"}
                  rows={4}
                />

                <button
                  className="remove-column-btn"
                  onClick={() => removeActionColumn(column.id)}
                >
                  Удалить столбец
                </button>
              </div>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
